import styled from 'styled-components'

export const CompleteArticlesTable = styled.table`
  margin-top: 15px;
  table-layout: fixed;

  * {
    font-size: 12px;
  }

  th,
  td {
    padding-top: 5px;
    padding-right: 10px;
    padding-bottom: 5px;
  }
`
